"use client";

import { cn } from "@/lib/utils";
import {
  LayoutDashboard,
  MessageSquare,
  Scale,
  Users,
  Wrench,
} from "lucide-react";

export type PrimaryView = "console" | "command" | "decision" | "agents" | "tools";

interface ContextualActionBarProps {
  activeView: PrimaryView | string;
  onViewChange: (view: PrimaryView) => void;
}

export function ContextualActionBar({
  activeView,
  onViewChange,
}: ContextualActionBarProps) {
  const views = [
    {
      id: "console" as PrimaryView,
      label: "Operational Console",
      mobileLabel: "Console",
      icon: LayoutDashboard,
    },
    {
      id: "command" as PrimaryView,
      label: "Command AURA",
      mobileLabel: "Command",
      icon: MessageSquare,
    },
    {
      id: "decision" as PrimaryView,
      label: "Decision Room",
      mobileLabel: "Rooms",
      icon: Scale,
    },
    {
      id: "agents" as PrimaryView,
      label: "Agents",
      mobileLabel: "Agents",
      icon: Users,
    },
    {
      id: "tools" as PrimaryView,
      label: "Tools",
      mobileLabel: "Tools",
      icon: Wrench,
    },
  ];

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 flex h-16 items-center gap-1 border-t border-border bg-card/95 px-2 pb-[env(safe-area-inset-bottom)] shadow-2xl backdrop-blur lg:static lg:h-10 lg:border-b lg:border-t-0 lg:bg-card/30 lg:px-4 lg:shadow-none">
      {views.map((view) => {
        const Icon = view.icon;
        const isActive = activeView === view.id;

        return (
          <button
            key={view.id}
            onClick={() => onViewChange(view.id)}
            className={cn(
              "flex min-w-0 flex-1 flex-col items-center justify-center gap-1 rounded-md px-2 py-2 text-[10px] leading-tight transition-all lg:flex-none lg:flex-row lg:gap-2 lg:px-3 lg:py-1.5 lg:text-xs",
              isActive
                ? "bg-muted text-foreground"
                : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
            )}
          >
            <Icon className="h-4 w-4 shrink-0 lg:h-3.5 lg:w-3.5" />
            <span className="lg:hidden">
              {view.mobileLabel}
            </span>
            <span className="hidden lg:inline">
              {view.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
